module.exports = __webpack_public_path__ + "static/img/kpicon-copy.d38f3af9.svg";